import { coreDao } from '../dao/core-dao'

export const coreService = {
  healthCheck: (): any => {
    return coreDao.healthCheck()
  },
  getLegalTermsAndConditions: async (): Promise<string> => {
    return coreDao.getLegalTermsAndConditions()
  },
  getLegalPrivacyPolicy: async (): Promise<string> => {
    return coreDao.getLegalPrivacyPolicy()
  },
  updateHustler: async (params: { profile: { username: string } }): Promise<void> => {
    return await coreDao.updateHustler(params)
  },
}
